module.exports = __webpack_public_path__ + "img/frontdeskrounded.c4db5e82.webp";